<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <strong v-text="$lang.parvandeh_status"></strong>
          </div>
          <LoadingSpinner :loading="isLoading" :text="$lang.receiving_data" />
          <b-row v-if="!isLoading">
            <b-col cols="12" class="mb-3 text-right">
              <b-button
                v-if="state === 'WASH-UP'"
                variant="primary"
                @click="getCompetencyOverview"
                v-text="$lang.show_competency_score"
              />
              <b-button
                v-if="state === 'COMPETENCY-OVERVIEW'"
                variant="outline-danger"
                @click="state = 'WASH-UP'"
              >
                <mdicon name="arrow-right" size="24" />
                <span v-text="$lang.back_to_washup" class="ml-2" />
              </b-button>
              <b-button
                class="ml-2"
                v-if="state === 'COMPETENCY-OVERVIEW'"
                variant="primary"
                @click="print"
              >
                <mdicon name="printer" size="24" />
                <span v-text="$lang.print" class="ml-2" />
              </b-button>
            </b-col>
            <b-col
              cols="12"
              class="table-responsive"
              v-if="state === 'WASH-UP'"
            >
              <table
                class="washup-table table b-table table-striped table-bordered text-center table-hover align-middle"
              >
                <thead role="rowgroup" class="text-center">
                  <tr role="row">
                    <th class="empty"></th>
                    <th
                      :colspan="exercises.length"
                      class="text-center align-middle"
                      role="columnheader"
                    >
                      تمرینات
                    </th>
                    <th role="columnheader" />
                  </tr>
                </thead>
                <thead role="rowgroup">
                  <tr role="row" class="text-center">
                    <th
                      class="empty text-danger text-center align-middle"
                      role="columnheader"
                    >
                      {{ $lang.candidate }}
                    </th>
                    <th
                      class="text-center align-middle"
                      :key="index"
                      v-for="(exercise, index) in exercises"
                      role="columnheader"
                      style="min-width: 200px; max-width: 200px"
                    >
                      {{ pathOr(null, ["caption"], exercise) }}
                    </th>
                    <th
                      class="text-center"
                      role="columnheader"
                      v-text="$lang.washup"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(item, index) in items">
                    <td class="align-middle">
                      <AvatarInfo
                        :avatarAddress="
                          pathOr(
                            null,
                            ['candidate', 'person', 'img_thumb'],
                            item
                          )
                        "
                        :imageAddress="
                          pathOr(
                            null,
                            ['candidate', 'person', 'img_original'],
                            item
                          )
                        "
                        :title="
                          pathOr(
                            '*****',
                            ['candidate', 'person', 'full_name'],
                            item
                          )
                        "
                        :description="
                          `${$lang.code}: ` +
                          pathOr(
                            '',
                            ['candidate', 'person_center_execute_code'],
                            item
                          )
                        "
                        :genderId="
                          +pathOr(
                            1,
                            ['candidate', 'person', 'gender', 'id'],
                            item
                          )
                        "
                        :personCode="
                          pathOr(null, ['candidate', 'person', 'code'], item)
                        "
                      />
                    </td>
                    <template v-for="(exercise, i) in exercises">
                      <td
                        class="align-middle"
                        :key="i"
                        v-if="getExercise(item, exercise)"
                      >
                        <span
                          v-if="
                            pathOr(
                              0,
                              ['evidence_log_count'],
                              findCell(item, exercise)
                            )
                          "
                          class="text-danger"
                        >
                          <span
                            class="d-md-inline-block d-none"
                            v-b-tooltip.hover
                            :title="
                              $lang.evidence_log_count.replace(
                                '{0}',
                                pathOr(
                                  0,
                                  ['evidence_log_count'],
                                  findCell(item, exercise)
                                )
                              )
                            "
                          >
                            <mdicon name="alert" />
                          </span>
                          <div
                            class="d-md-none font-weight-bold d-flex flex-column"
                          >
                            <mdicon name="alert-decagram" />
                            <small class="font-weight-bold">{{
                              $lang.evidence_log_count.replace(
                                "{0}",
                                pathOr(
                                  0,
                                  ["evidence_log_count"],
                                  findCell(item, exercise)
                                )
                              )
                            }}</small>
                          </div>
                        </span>
                        <span>
                          <div
                            v-if="findCell(item, exercise, 'is_absent')"
                            class="text-danger font-weight-bold"
                            v-text="$lang.not_register_in_parvandeh"
                          />
                          <strong
                            v-else
                            v-text="
                              pathOr(
                                null,
                                ['caption'],
                                findCell(item, exercise)
                              )
                            "
                            class="text-primary cursor_pointer"
                            @click="showStatusModal(item, exercise)"
                          />
                        </span>
                      </td>
                      <td :key="i" v-else class="bg-secondary" />
                    </template>
                    <td>
                      <span
                        v-if="hasWashUp(item)"
                        @click="goToEditWashUp(item)"
                        v-b-tooltip.hover
                        :title="$lang.washup_job"
                        class="cursor_pointer"
                      >
                        <i
                          area-hidden="true"
                          class="fa fa-edit fa-lg text-success"
                        />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col
              cols="12"
              class="table-responsive"
              v-if="state === 'COMPETENCY-OVERVIEW'"
              id="section-to-print"
            >
              <table
                class="washup-table table b-table table-striped table-bordered text-center table-hover align-middle"
              >
                <thead role="rowgroup" class="text-center">
                  <tr role="row">
                    <th class="empty"></th>
                    <th
                      :colspan="competencyExercises.length"
                      class="text-center align-middle"
                      role="columnheader"
                    >
                      {{ $lang.competencies }}
                    </th>
                  </tr>
                </thead>
                <thead role="rowgroup">
                  <tr role="row" class="text-center">
                    <th
                      class="empty text-danger text-center align-middle"
                      role="columnheader"
                    >
                      {{ $lang.candidate }}
                    </th>
                    <th
                      class="text-center align-middle"
                      :key="index"
                      v-for="(competency, index) in competencyExercises"
                      role="columnheader"
                    >
                      {{ pathOr(null, ["caption"], competency) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(item, index) in competencyItems">
                    <td class="align-middle">
                      <AvatarInfo
                        :avatarAddress="
                          pathOr(
                            null,
                            ['candidate', 'person', 'img_thumb'],
                            item
                          )
                        "
                        :imageAddress="
                          pathOr(
                            null,
                            ['candidate', 'person', 'img_original'],
                            item
                          )
                        "
                        :title="
                          pathOr(
                            '*****',
                            ['candidate', 'person', 'full_name'],
                            item
                          )
                        "
                        :description="
                          `${$lang.code}: ` +
                          pathOr(
                            '',
                            ['candidate', 'person_center_execute_code'],
                            item
                          )
                        "
                        :genderId="
                          +pathOr(
                            1,
                            ['candidate', 'person', 'gender', 'id'],
                            item
                          )
                        "
                        :personCode="
                          pathOr(null, ['candidate', 'person', 'code'], item)
                        "
                      />
                    </td>
                    <template v-for="(competency, i) in item.items">
                      <td class="align-middle" :key="i">
                        <span v-text="pathOr(null, ['score'], competency)" />
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      variant="primary"
      hide-header
      hide-footer
      content-class="border-primary"
      size="md"
      v-model="statusModal"
      :ok-title="$lang.submitButton"
    >
      <b-card>
        <div slot="header">تغییر وضعیت پرونده</div>
        <LoadingSpinner :loading="statusLoading" :text="$lang.sending_data" />
        <b-form v-if="!statusLoading" @submit.prevent="changeStatus">
          <b-form-group
            :label="$lang.case_parvandeh_status"
            label-for="case_parvandeh_status"
            :label-cols="12"
          >
            <selectFind
              name="case_parvandeh_status"
              :options="parvandehStatusOptions"
              v-model="status_selected"
              label="text"
              id="value"
            />
          </b-form-group>
          <div slot="footer" class="text-right">
            <b-button type="submit" variant="success" class="mr-2">
              {{ $lang.submitButton }}
              <i class="fa fa-check" />
            </b-button>
            <b-button variant="danger" @click="statusModal = false">
              {{ $lang.close }}
              <i class="fa fa-ban" />
            </b-button>
          </div>
        </b-form>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import AvatarInfo from "@/components/global/AvatarInfo";
import { pathOr, includes } from "ramda";
import {
  generateApiUrl,
  setUniqueArrayOfObjects,
  renderEumOptions,
} from "@/shared/utils";

export default {
  name: "search-wash-up",
  components: {
    LoadingSpinner,
    AvatarInfo,
  },
  data() {
    return {
      center_execute_id: this.$route.params.center_execute_id,
      exercises: [],
      items: [],
      isLoading: false,
      canter_execute_status: null,
      caseId: null,
      statusModal: false,
      statusLoading: false,
      status_selected: null,
      userExecutiveRoleId: null,
      state: "WASH-UP",
      competencyExercises: [],
      competencyItems: [],
    };
  },
  computed: {
    parvandehStatusOptions() {
      /* 
        وضعیت پرونده: caseStatusId
        1: بررسی ارزیاب
        2: بررسی QC
        3: تایید QC
        4: تایید مدیر کانون
        5: تکمیل واشاپ
        6: تایید ویراستار
      */
      /* 
        نقش کانونی: userExecutiveRoleId
        1: شرکت کننده
        2: ارزیاب
        3: مدیر کانون
        4: ناظر کیفی
        5: واشاپر
        6: تسهیل گر
        7: ویراستار
      */
      let options = renderEumOptions("case_status");
      if (includes(this.userExecutiveRoleId, [5, 7])) {
        options = renderEumOptions("case_status").filter((item) =>
          includes(item.value, [5, 6])
        );
      }
      return options;
    },
  },
  created() {
    this.getWashUps();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    setUniqueArrayOfObjects,
    renderEumOptions,
    print() {
      window.print();
    },
    goToEditWashUp(item) {
      this.$router.push({
        name: "editWashUp",
        params: {
          center_execute_id: this.center_execute_id,
          center_execute_candidate_id: pathOr(null, ["candidate", "id"], item),
        },
      });
    },
    getExercise(item, exercise) {
      const exercises = pathOr([], ["center_execute_case"], item)
        .map((row) => pathOr(null, ["exercise"], row))
        .filter(Boolean);
      const id = pathOr(false, ["id"], exercise);
      return exercises.find(
        (exercise) => pathOr(null, ["id"], exercise) === id
      );
    },
    findCell(item, exercise, key = "status") {
      const centerExecuteCases = pathOr([], ["center_execute_case"], item);
      const centerExecuteCase = centerExecuteCases.find(
        (row) =>
          pathOr(null, ["exercise", "id"], row) ===
          pathOr(false, ["id"], exercise)
      );
      return pathOr(null, [key], centerExecuteCase);
    },
    getCaseId(item, exercise) {
      const centerExecuteCases = pathOr([], ["center_execute_case"], item);
      const centerExecuteCase = centerExecuteCases.find(
        (row) =>
          pathOr(null, ["exercise", "id"], row) ===
          pathOr(false, ["id"], exercise)
      );
      return pathOr(null, ["id"], centerExecuteCase);
    },
    hasWashUp(item) {
      const exercises = pathOr([], ["center_execute_case"], item);
      const checkExercises = exercises.some((row) =>
        pathOr(false, ["allow_washup"], row)
      );
      const isAcManager = includes(this.userExecutiveRoleId, [
        3,
        5,
        6,
        7,
        null,
      ]);
      return checkExercises && isAcManager;
    },
    showStatusModal(item, exercise) {
      const status = this.findCell(item, exercise);
      this.status_selected = {
        text: pathOr(null, ["caption"], status),
        value: pathOr(null, ["id"], status),
      };
      this.caseId = this.getCaseId(item, exercise);

      /* 
        وضعیت پرونده: caseStatusId
        1: بررسی ارزیاب
        2: بررسی QC
        3: تایید QC
        4: تایید مدیر کانون
        5: تکمیل واشاپ
        6: تایید ویراستار
      */
      /* 
        نقش کانونی: userExecutiveRoleId
        1: شرکت کننده
        2: ارزیاب
        3: مدیر کانون
        4: ناظر کیفی
        5: واشاپر
        6: تسهیل گر
        7: ویراستار
      */
      const allowShow = includes(this.userExecutiveRoleId, [3, 5, 7]);
      if (!allowShow) {
        return this.$notify.warning(
          "تغییر وضعیت پرونده برای شما امکانپذیر نمی باشد"
        );
      }
      this.statusModal = true;
    },
    async changeStatus() {
      try {
        this.statusLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_case_status"],
          [this.center_execute_id, this.caseId]
        );
        const payload = {
          status: pathOr(null, ["value"], this.status_selected),
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.statusModal = false;
        this.getWashUps();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.statusLoading = false;
      }
    },
    async getWashUps() {
      try {
        this.isLoading = true;
        const url = generateApiUrl(
          ["kanoon", "washup"],
          [this.center_execute_id]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.canter_execute_status = pathOr(
          null,
          ["canter_execute_status", "id"],
          data
        );
        this.userExecutiveRoleId = pathOr(
          null,
          ["user_executive_role", "id"],
          data
        );
        this.items = pathOr([], ["items"], data);
        const centerExecuteCaseItems = this.items
          .map((item) => pathOr([], ["center_execute_case"], item))
          .flat()
          .map((row) => pathOr(null, ["exercise"], row));
        this.exercises = setUniqueArrayOfObjects(centerExecuteCaseItems, "id");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getCompetencyOverview() {
      try {
        this.state = "COMPETENCY-OVERVIEW";
        this.isLoading = true;
        const url = generateApiUrl(
          ["kanoon", "center_execute_competency_overview"],
          [this.center_execute_id]
        );
        const response = await this.$httpService.get(url);
        this.competencyItems = pathOr(null, ["data", "data"], response);
        const centerExecuteCaseItems = this.competencyItems
          .map((item) => pathOr([], ["items"], item))
          .flat()
          .map((row) => {
            return {
              ...pathOr(null, ["competency"], row),
              score: pathOr(null, ["score"], row),
            };
          });
        this.competencyExercises = setUniqueArrayOfObjects(
          centerExecuteCaseItems,
          "id"
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
